import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import {AddressFormatter, optionsTemplate} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class PartnerRoleForm extends React.Component {

    render() {
        const filterable = true;
        const sortable = true;
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2 col-md-push-10">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-md-10 col-md-pull-2">
                        <TextInput name="name" value={this.props.values.name} label="Megnevezés" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("name")}/>
                    </div>
                </div>
                {
                    this.props.values[this.props.componentConfig.idfield] && 
                    (
                        <div className="row form-row">
                        <div className="col-sm-12">
                            <br/>
                            <label>Partnerek</label>
                            <SelectorGrid
                                {...this.props.getFieldProps("partners")}
                                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                name="partners"
                                addRowProps={{
                                    optionsTemplate: optionsTemplate("partner"),
                                }}
                                columns={{
                                    name: {
                                        header: 'Név',
                                        width: 3,
                                        filterable,
                                        sortable
                                    },
                                    address: {
                                        header: 'Cím',
                                        width: 3,
                                        renderer: AddressFormatter
                                    },
                                    taxid: {
                                        header: 'Adószám',
                                        width: 2,
                                        filterable,
                                        sortable
                                    },
                                    eu_taxid: {
                                        header: 'EU adószám',
                                        width: 2,
                                        filterable,
                                        sortable
                                    },
                                    email: {
                                        header: 'Email',
                                        width: 2,
                                        filterable,
                                        sortable
                                    }
                                }}
                                data={this.props.values}
                                orderBy={{field: "name", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                    </div>
                    )
                }
            </form>
        );
    }
}


export default createForm(PartnerRoleForm);
